module.exports = __webpack_public_path__ + "static/servicecorsal2-587fe484c124957473cfa20c88f40ef8.png";